import React, { useState, useEffect, useRef } from 'react';
import { NOTE_MAX } from './anchors';

// ── Writing or editing the note on a mark ────────────────────────────────────
// Sits near the top of the screen rather than beside the words: on a phone the
// keyboard takes the bottom half, and a panel anchored to the selection would
// end up under it.
export function NoteEditor({ t, title, initial = '', onSave, onCancel, onDelete }) {
  const [text, setText] = useState(initial);
  const areaRef = useRef(null);
  useEffect(() => { areaRef.current?.focus(); }, []);

  const left = NOTE_MAX - text.length;
  const onKeyDown = e => {
    if (e.key === 'Escape') { e.preventDefault(); onCancel(); }
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); onSave(text); }
  };

  return (
    <div className="anno-note-backdrop" onMouseDown={e => { if (e.target === e.currentTarget) onCancel(); }}>
      <div className="anno-note-editor" role="dialog" aria-modal="true" aria-label={t.noteTitle}>
        <div className="anno-note-head">
          <span className="anno-note-title">{t.noteTitle}</span>
          <span className="anno-note-ref">{title}</span>
        </div>
        <textarea ref={areaRef} className="anno-note-input" value={text} maxLength={NOTE_MAX}
          rows={5} placeholder={t.notePlaceholder}
          onChange={e => setText(e.target.value)} onKeyDown={onKeyDown} />
        <div className="anno-note-actions">
          {onDelete && initial && (
            <button type="button" className="anno-note-btn anno-tool-danger" onClick={onDelete}>{t.deleteNote}</button>
          )}
          {left < 200 && <span className="anno-note-count">{t.left(left)}</span>}
          <span className="anno-note-spacer" />
          <button type="button" className="anno-note-btn" onClick={onCancel}>{t.cancel}</button>
          <button type="button" className="anno-note-btn anno-note-save" onClick={() => onSave(text)}>{t.save}</button>
        </div>
      </div>
    </div>
  );
}
